import { render, staticRenderFns } from "./ProhibitBindingColumn.vue?vue&type=template&id=1899ac05"
import script from "./ProhibitBindingColumn.vue?vue&type=script&lang=ts"
export * from "./ProhibitBindingColumn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports